// React 18 entry point. CRA's webpack expects either src/index.js or
// src/index.tsx as the root module — it imports this, finds the <div id="root">
// in public/index.html, and mounts the React tree there.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
